<template>
<v-dialog
    :value="dialog"
    @input="setDialogAction(!dialog)"
    max-width="600px"
    class="rounded-xl"
>
  <v-form ref="formAchievementType">
    <v-card  class="rounded-xl">
      <v-card-title>
        Тип достижения
      </v-card-title>
      <v-card-text>
        <v-text-field
          :value="name"
          @input="setAchievementName"
          outlined
          class="rounded-xl"
          label="Название"
        >
        </v-text-field>
        <v-select outlined
                  :items="group_list"
                  item-text="name"
                  item-value="id"
                  clearable
                  :value="group"
                  @input="setAchievementGroup"
                  :color="$store.state.achievement.side_color"
                  label="Вид достижения"
                  class="rounded-xl"
                  no-data-text="Виды достижений отсутсвуют"
        >
        </v-select>
      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn
            v-if="editMode"
            :color="$store.state.achievement.side_color"
            class="white--text"
            @click="updateAchievementType"
        >
          Обновить
        </v-btn>
        <v-btn
            v-else
            :color="$store.state.achievement.side_color"
            class="white--text"
            @click="createAchievementType"
        >
          Создать
        </v-btn>
        <v-btn
            :color="$store.state.achievement.btn_color"
            class="white--text"
            @click="setDialogAction(false)"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "FormTypeAchievement",

  data() {
    return {
      group_list: [
        {id: 1, name: "Обучающиеся"},
        {id: 5, name: "Преподаватели"}
      ]
    }
  },

  computed: {
    ...mapState({
      name: state => state.achievement_type.payload.name,
      group: state => state.achievement_type.payload.group,
      dialog: state => state.achievement_type.dialog,
      editMode: state => state.achievement_type.edit_mode_form,

    }),
  },

  methods: {
    ...mapMutations({
      setAchievementName: 'achievement_type/setAchievementName',
      setAchievementGroup: "achievement_type/setAchievementGroup",
    }),

    ...mapActions({
      setDialogAction: 'achievement_type/setDialogAction',
      createAchievementType: 'achievement_type/createAchievementType',
      updateAchievementType: 'achievement_type/updateAchievementType',
    }),
  },
}
</script>

<style scoped>

</style>